import { MdPause, MdPlayCircleFilled } from 'react-icons/md';

export default function PlayPauseButton({ runningSession }) {
  const Icon = runningSession ? MdPause : MdPlayCircleFilled;
  return <Icon fontSize="2em" />;
}
